import React, { useState } from "react";
import Surface from "../../theme/Surface";
import { updateProfile } from "../../api";

/**
 * GenderRequiredCard — the feed is gender-segregated (like practice calls),
 * so a user with no gender on file has no feed to show. One-time prompt;
 * gender is set-once (admin correction only afterwards), so say that plainly.
 *
 * Props: onSet — () => void, called after a successful save (re-fetch eligibility)
 */
export default function GenderRequiredCard({ onSet }) {
  const [choice, setChoice] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const save = async () => {
    if (!choice) return;
    setSaving(true);
    setError(null);
    try {
      await updateProfile({ gender: choice });
      onSet && onSet();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Surface className="rounded-2xl px-4 py-4 max-w-md mx-auto">
      <p className="text-sm font-medium" style={{ color: "var(--parchment)" }}>
        One thing first
      </p>
      <p className="text-xs mt-1" style={{ color: "var(--parchment-dim)" }}>
        Like practice calls, the feed is separate for brothers and sisters. Set your gender to
        see your feed — this is set once and can only be corrected by support afterwards.
      </p>
      <div className="flex gap-2 mt-3">
        {[["male", "Brother"], ["female", "Sister"]].map(([value, label]) => (
          <button
            key={value}
            onClick={() => setChoice(value)}
            className="dt-ghost-btn flex-1 px-3 py-2 rounded-xl text-sm"
            style={choice === value ? { borderColor: "var(--gold)", color: "var(--gold-bright)" } : undefined}
          >
            {label}
          </button>
        ))}
      </div>
      {error && (
        <p className="text-xs mt-2 px-1" style={{ color: "var(--tag-rose)" }}>{error}</p>
      )}
      <button
        onClick={save}
        disabled={!choice || saving}
        className="dt-ghost-btn w-full px-3 py-2 rounded-xl text-sm mt-3 disabled:opacity-50"
      >
        {saving ? "Saving…" : "Continue"}
      </button>
    </Surface>
  );
}
